import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const listSubheader = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiListSubheader"] => ({
	root: {
		color: undefined,
		padding: `${spacing(2)} ${spacing(1)}`,
	},
});

export default listSubheader;
